/* Bloquinho: tira-dúvidas interativo (FAQ) da loja. Sem servidor e sem dependências. */
(function () {
  var root = document.getElementById('bloquinho');
  if (!root || root.getAttribute('data-ready')) return;

  var KB = null;
  try { KB = JSON.parse(document.getElementById('bloquinho-kb').textContent); } catch (e) { KB = null; }
  if (!KB || !KB.topics || !KB.topics.length) return;
  root.setAttribute('data-ready', '1');

  var IMG_MASCOTE = root.getAttribute('data-mascote') || '';
  var IMG_CORPO = root.getAttribute('data-corpo') || '';
  var IMG_MAO = root.getAttribute('data-mao') || '';
  var IMG_ROSTO = root.getAttribute('data-rosto') || '';
  var WHATS = (root.getAttribute('data-whatsapp') || '').replace(/\D/g, '');

  var STORE_KEY = 'bq-faq-v1', TEASER_KEY = 'bq-teaser-v1';
  var history = [];
  var busy = false;

  function safeGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  try {
    var saved = JSON.parse(safeGet(STORE_KEY) || '[]');
    if (Array.isArray(saved)) {
      history = saved.filter(function (m) {
        return m && (m.role === 'user' || m.role === 'bot') && typeof m.text === 'string';
      }).slice(-30);
    }
  } catch (e) { history = []; }
  function persist() { safeSet(STORE_KEY, JSON.stringify(history.slice(-30))); }

  /* ---------- base de respostas e busca ---------- */
  var STOP = ('a o as os um uma uns umas de do da dos das em no na nos nas por para com sem que e ou se eu me meu minha meus minhas ' +
    'seu sua voces voce vcs vc ja mais muito como qual quais quando onde quem tem ter ha foi ser sao esta estou eh pra pro mim ate ao aos ' +
    'gostaria queria quero preciso saber posso fazer favor').split(' ');

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stem(t) {
    if (t.length > 4 && t.charAt(t.length - 1) === 's') t = t.slice(0, -1);
    return t.length > 5 ? t.slice(0, 5) : t;
  }
  function stems(s) {
    var out = [];
    norm(s).split(' ').forEach(function (t) {
      if (!t || STOP.indexOf(t) !== -1) return;
      var st = stem(t);
      if (out.indexOf(st) === -1) out.push(st);
    });
    return out;
  }

  var items = [];
  KB.topics.forEach(function (topic) {
    (topic.items || []).forEach(function (it) {
      items.push({ topic: topic, it: it, qs: stems(it.q), ks: stems(it.k || '') });
    });
  });

  function search(text) {
    var qs = stems(text);
    if (!qs.length) return [];
    var res = [];
    items.forEach(function (e) {
      var score = 0, matched = 0;
      qs.forEach(function (s) {
        var inQ = e.qs.indexOf(s) !== -1, inK = e.ks.indexOf(s) !== -1;
        if (inQ) score += 3;
        if (inK) score += 2;
        if (inQ || inK) matched++;
      });
      if (matched && (score >= 3 || (matched === qs.length && score >= 2))) {
        res.push({ e: e, score: score, cov: matched / qs.length });
      }
    });
    res.sort(function (a, b) { return (b.score - a.score) || (b.cov - a.cov) || (a.e.it.q.length - b.e.it.q.length); });
    return res;
  }

  /* ---------- DOM ---------- */
  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    return n;
  }
  function svg(path) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.4'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', path); s.appendChild(p);
    return s;
  }

  var dock = el('div', 'bq-dock');
  var teaser = el('div', 'bq-teaser', { role: 'status' });
  var teaserBtn = el('button', '', { type: 'button', style: 'all:unset;cursor:pointer;display:block;' });
  teaserBtn.textContent = 'Ficou na dúvida? Pergunta pra mim!';
  var teaserX = el('button', 'bq-teaser__x', { type: 'button', 'aria-label': 'Fechar dica' });
  teaserX.textContent = '×';
  teaser.appendChild(teaserBtn); teaser.appendChild(teaserX);

  var launcher = el('button', 'bq-launcher', { type: 'button', 'aria-haspopup': 'dialog', 'aria-expanded': 'false', 'aria-label': 'Está com dúvida? Fale com o Bloquinho' });
  var rosto = el('span', 'bq-rosto', { 'aria-hidden': 'true' });
  var pop = el('span', 'bq-pop');
  var fig = el('span', 'bq-fig');
  fig.appendChild(el('img', '', { src: IMG_CORPO || IMG_MASCOTE, alt: '', width: '88', height: '88', draggable: 'false' }));
  if (IMG_CORPO && IMG_MAO) fig.appendChild(el('img', 'bq-mao', { src: IMG_MAO, alt: '', width: '88', height: '88', draggable: 'false' }));
  pop.appendChild(fig);
  rosto.appendChild(pop);
  var txt = el('span', 'bq-brick__txt');
  var small = el('small'); small.textContent = 'Está com dúvida?';
  var strong = el('strong'); strong.textContent = 'Fale com o Bloquinho';
  txt.appendChild(small); txt.appendChild(strong);
  var dot = el('span', 'bq-status', { 'aria-hidden': 'true' });
  launcher.appendChild(rosto); launcher.appendChild(dot); launcher.appendChild(txt);
  dock.appendChild(teaser); dock.appendChild(launcher);

  /* mascote interativo: o rostinho acompanha o cursor / dedo */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function look(x, y) {
    var r = rosto.getBoundingClientRect();
    var dx = x - (r.left + r.width / 2), dy = y - (r.top + r.height / 2);
    var d = Math.sqrt(dx * dx + dy * dy) || 1, k = Math.min(1, d / 260);
    rosto.style.setProperty('--bq-tx', (dx / d * 3.5 * k).toFixed(2) + 'px');
    rosto.style.setProperty('--bq-ty', (dy / d * 3.5 * k).toFixed(2) + 'px');
    rosto.style.setProperty('--bq-rot', (dx / d * 4 * k).toFixed(2) + 'deg');
  }
  if (!reduce) {
    window.addEventListener('pointermove', function (e) { if (!isOpenFlag()) look(e.clientX, e.clientY); }, { passive: true });
  }
  function isOpenFlag() { return root.classList.contains('bq-open'); }

  var panel = el('div', 'bq-panel', { role: 'dialog', 'aria-label': 'Tira-dúvidas do Bloquinho', 'aria-modal': 'false' });
  var pMascote = el('img', 'bq-panel__mascote', { src: IMG_MASCOTE, alt: '', width: '96', height: '96', 'aria-hidden': 'true' });
  var head = el('div', 'bq-head');
  var headT = el('div', 'bq-head__t');
  var hTitle = el('strong'); hTitle.textContent = 'Bloquinho';
  var hSub = el('span'); hSub.textContent = 'Tira-dúvidas da loja';
  headT.appendChild(hTitle); headT.appendChild(hSub);
  var closeBtn = el('button', 'bq-x', { type: 'button', 'aria-label': 'Fechar' });
  closeBtn.appendChild(svg('M6 6l12 12M18 6L6 18'));
  head.appendChild(headT); head.appendChild(closeBtn);

  var log = el('div', 'bq-log', { role: 'log', 'aria-live': 'polite', 'aria-relevant': 'additions' });
  var chips = el('div', 'bq-chips', { role: 'group', 'aria-label': 'Sugestões' });
  var form = el('form', 'bq-form', { autocomplete: 'off' });
  var input = el('input', 'bq-input', { type: 'text', maxlength: '200', placeholder: 'Escreva sua dúvida', 'aria-label': 'Escreva sua dúvida', enterkeyhint: 'search' });
  var sendBtn = el('button', 'bq-send', { type: 'submit', 'aria-label': 'Buscar resposta' });
  sendBtn.appendChild(svg('M5 12h14M13 6l6 6-6 6'));
  form.appendChild(input); form.appendChild(sendBtn);
  var note = el('p', 'bq-note');
  note.appendChild(document.createTextNode('Respostas prontas, baseadas nas políticas da loja. '));
  var noteLink = contactLink();
  if (noteLink) { noteLink.textContent = 'Falar com a equipe'; note.appendChild(noteLink); }

  panel.appendChild(pMascote); panel.appendChild(head); panel.appendChild(log);
  panel.appendChild(chips); panel.appendChild(form); panel.appendChild(note);
  root.appendChild(dock); root.appendChild(panel);

  function contactHref() { return KB.contact && KB.contact.href ? KB.contact.href : ''; }
  function contactLink() {
    var href = contactHref();
    if (!href) return null;
    return el('a', '', { href: href });
  }
  function whatsHref() { return WHATS ? 'https://wa.me/' + WHATS + '?text=' + encodeURIComponent('Olá! Vim pelo site e preciso de ajuda.') : ''; }

  function linkEl(l) {
    var external = /^https?:/i.test(l.href);
    var a = el('a', 'bq-link', { href: l.href });
    if (external) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer'); }
    a.textContent = l.label;
    return a;
  }

  function fillText(box, text) {
    String(text).trim().split(/\n{2,}/).forEach(function (para) {
      var p = el('p');
      p.textContent = para;
      box.appendChild(p);
    });
  }

  function scrollDown() { log.scrollTop = log.scrollHeight; }
  function positionRow(row, role) {
    if (role !== 'user' && row.offsetHeight > log.clientHeight - 24) log.scrollTop = Math.max(row.offsetTop - 10, 0);
    else scrollDown();
  }

  function addRow(role, text, links, save) {
    var row = el('div', 'bq-msg' + (role === 'user' ? ' bq-msg--user' : ''));
    if (role !== 'user') {
      var av = el('span', 'bq-av', { 'aria-hidden': 'true' });
      av.style.backgroundImage = 'url("' + IMG_ROSTO + '")';
      row.appendChild(av);
    }
    var b = el('div', 'bq-bubble');
    fillText(b, text);
    var good = (links || []).filter(function (l) { return l && l.href && l.label; });
    if (good.length) {
      var box = el('div', 'bq-links');
      good.forEach(function (l) { box.appendChild(linkEl(l)); });
      b.appendChild(box);
    }
    row.appendChild(b);
    log.appendChild(row);
    positionRow(row, role);
    if (save) { history.push({ role: role, text: text, links: good }); persist(); }
    return row;
  }

  function addTyping() {
    var row = el('div', 'bq-msg');
    var av = el('span', 'bq-av', { 'aria-hidden': 'true' });
    av.style.backgroundImage = 'url("' + IMG_ROSTO + '")';
    var b = el('div', 'bq-bubble', { 'aria-label': 'Bloquinho está procurando' });
    var t = el('span', 'bq-typing'); t.appendChild(el('i')); t.appendChild(el('i')); t.appendChild(el('i'));
    b.appendChild(t); row.appendChild(av); row.appendChild(b);
    log.appendChild(row); scrollDown();
    return row;
  }

  /* ---------- sugestões (chips) ---------- */
  function setChips(list) {
    chips.textContent = '';
    list.forEach(function (c) {
      var b = el('button', 'bq-chip' + (c.ghost ? ' bq-chip--ghost' : ''), { type: 'button' });
      b.textContent = c.label;
      b.addEventListener('click', c.run);
      chips.appendChild(b);
    });
  }
  function topicChips() {
    return KB.topics.map(function (t) { return { label: t.title, run: function () { pickTopic(t); } }; });
  }
  function questionChips(topic, exceptItem) {
    return (topic.items || []).filter(function (it) { return it !== exceptItem; })
      .map(function (it) { return { label: it.q, run: function () { pickQuestion(it, topic); } }; });
  }
  function afterAnswerChips(topic, it) {
    var list = questionChips(topic, it).slice(0, 3);
    list.push({ label: 'Ver outros assuntos', ghost: true, run: showTopics });
    list.push({ label: 'Falar com a equipe', ghost: true, run: talkToTeam });
    return list;
  }

  /* ---------- fluxo ---------- */
  function reply(text, links, chipList, delay) {
    busy = true;
    setChips([]);
    var typing = addTyping();
    setTimeout(function () {
      typing.remove();
      var row = addRow('bot', text, links, true);
      setChips(chipList || topicChips());
      positionRow(row, 'bot');
      busy = false;
    }, delay == null ? 450 : delay);
  }

  function showTopics() {
    if (busy) return;
    addRow('user', 'Ver outros assuntos', null, true);
    reply('Claro! Sobre o que você quer saber?', null, topicChips());
  }
  function pickTopic(topic) {
    if (busy) return;
    addRow('user', topic.title, null, true);
    var list = questionChips(topic);
    list.push({ label: 'Ver outros assuntos', ghost: true, run: showTopics });
    reply('Sobre ' + topic.title.toLowerCase() + ', o que você quer saber?', null, list);
  }
  function pickQuestion(it, topic) {
    if (busy) return;
    addRow('user', it.q, null, true);
    reply(it.a, it.links, afterAnswerChips(topic, it));
  }
  function talkToTeam() {
    if (busy) return;
    addRow('user', 'Falar com a equipe', null, true);
    var links = [];
    if (contactHref()) links.push({ label: (KB.contact && KB.contact.label) || 'Ir para Contato', href: contactHref() });
    if (whatsHref()) links.push({ label: 'Chamar no WhatsApp', href: whatsHref() });
    reply('Sem problema! Fale com a equipe pelo canal de atendimento. Informe seu nome, o número do pedido (se já comprou) e o que aconteceu ou o que você quer saber.', links, [
      { label: 'Ver assuntos', ghost: true, run: showTopics }
    ]);
  }

  function handleText(raw) {
    var text = String(raw || '').trim();
    if (!text || busy) return;
    addRow('user', text, null, true);
    input.value = '';
    var n = norm(text);
    if (/^(oi|ola|opa|e ai|bom dia|boa tarde|boa noite|oii+)( bloquinho)?$/.test(n)) {
      reply('Oi! Sobre o que você quer saber?', null, topicChips());
      return;
    }
    if (/obrigad|valeu|brigad/.test(n)) {
      reply('De nada! Se precisar de mais alguma coisa, é só chamar.', null, topicChips());
      return;
    }
    var res = search(text);
    if (res.length) {
      var top = res[0].e;
      var more = res.slice(1, 4).map(function (r) {
        return { label: r.e.it.q, run: function () { pickQuestion(r.e.it, r.e.topic); } };
      });
      more.push({ label: 'Ver outros assuntos', ghost: true, run: showTopics });
      more.push({ label: 'Falar com a equipe', ghost: true, run: talkToTeam });
      reply(top.it.a, top.it.links, more);
      return;
    }
    var links = contactHref() ? [{ label: (KB.contact && KB.contact.label) || 'Ir para Contato', href: contactHref() }] : [];
    if (whatsHref()) links.push({ label: 'Chamar no WhatsApp', href: whatsHref() });
    reply(KB.fallback || 'Não encontrei essa resposta por aqui.', links, topicChips());
  }

  function renderAll() {
    log.textContent = '';
    addRow('bot', KB.greeting || 'Oi! Eu sou o Bloquinho. Escolha um assunto ou escreva sua dúvida.', null, false);
    history.forEach(function (m) { addRow(m.role, m.text, m.links, false); });
    setChips(topicChips());
  }

  /* ---------- abrir / fechar ---------- */
  var isOpen = false;
  function open() {
    isOpen = true; hideTeaser();
    root.classList.add('bq-open'); launcher.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input.focus({ preventScroll: true }); scrollDown(); }, 80);
  }
  function close() {
    isOpen = false;
    root.classList.remove('bq-open'); launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  }
  function hideTeaser() { teaser.classList.remove('bq-on'); }

  launcher.addEventListener('click', open);
  teaserBtn.addEventListener('click', open);
  teaserX.addEventListener('click', hideTeaser);
  closeBtn.addEventListener('click', close);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
  form.addEventListener('submit', function (e) { e.preventDefault(); handleText(input.value); });

  renderAll();

  if (!safeGet(TEASER_KEY)) {
    setTimeout(function () {
      if (isOpen) return;
      teaser.classList.add('bq-on'); safeSet(TEASER_KEY, '1');
      setTimeout(hideTeaser, 9000);
    }, 5000);
  }
})();